import styled, { css } from "styled-components";
import { Flex } from "../Flex";
import { getPropertyByMedia, getThemeMedia, getThemeSpace } from "../helpers";
export const BoxOverlay = styled.div `
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	opacity: ${({ sidebar }) => (sidebar ? 0.4 : 0)};
	transition: opacity 350ms ease-in-out;
	display: ${({ sidebar }) => (sidebar ? "block" : "none")};

	z-index: 150;
	height: 100vh;
	width: 100%;
	background-color: var(--neutral-black-15);
`;
export const SidebarNav = styled.div `
	@keyframes slideSidebarNavToLeft {
		from {
			right: -100%;
		}

		to {
			right: 0;
		}
	}

	@keyframes slideSidebarNavToRight {
		from {
			right: 0;
		}

		to {
			right: -400%;
		}
	}

	display: flex;
	flex-direction: column;
	flex: 1;

	position: fixed;
	right: -400%;
	top: 0;
	animation: slideSidebarNavToLeft 350ms 0ms ease-in-out forwards;

	&.closing {
		animation: slideSidebarNavToRight 350ms 0ms ease-in-out forwards;
	}


	z-index: ${({ index }) => (index !== undefined ? `15${index}` : "200")};
	background: var(--surface-white);

	${({ width }) => width
    ? getPropertyByMedia("width", width, "100%")
    : css `
					width: 100%;
			  `};
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth, "500px")};
	height: ${({ safetyHeight }) => safetyHeight}px;
	${({ height }) => height && getPropertyByMedia("height", height)};

	${({ padding }) => padding
    ? css `
					padding: ${getPropertyByMedia("padding", padding)};
			  `
    : css `
					padding: ${getThemeSpace("24")} 0 ${getThemeSpace("40")};
			  `}

	${({ side, sidebar }) => side === "left" &&
    css `
			right: auto;
			left: ${sidebar ? "0" : "-100%"};
		`}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			height: 100vh;

			${({ padding }) => padding
    ? css `
							padding: ${getPropertyByMedia("padding", padding)};
					  `
    : css `
							padding: ${getThemeSpace("48")} 0 ${getThemeSpace("40")};
					  `}
		}
	}

	@media screen {
		@media (max-width: ${getThemeMedia("medium")}) {
			${({ openFromBottom, sidebar }) => openFromBottom &&
    css `
					right: initial;
					top: initial;
					bottom: ${sidebar ? "-100px" : "-100%"};

					border-radius: 8px 8px 0 0;
					padding-bottom: 124px;
				`}
		}
	}
`;
export const SidebarHeader = styled(Flex) `
	${({ showReturnButton }) => !showReturnButton &&
    css `
			padding: 0 0 ${getThemeSpace("16")};
			margin: 0 ${getThemeSpace("16")} ${getThemeSpace("16")};
			border-bottom: 2px solid var(--border-active);
		`}

	button {
		position: absolute;
		top: ${getThemeSpace("16")};

		&[data-testid*='promotion-return-button-'] {
			left: ${getThemeSpace("16")};
		}

		&[data-testid*='promotion-close-button-'] {
			right: ${getThemeSpace("16")};
		}
	}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			${({ showReturnButton }) => !showReturnButton &&
    css `
					margin: 0 ${getThemeSpace("56")} ${getThemeSpace("16")};
				`}
		}
	}
`;
//# sourceMappingURL=styles.js.map